import { NgOtpInputConfig } from "ng-otp-input";

export const otpVerificationConfiguration: NgOtpInputConfig =
{
  allowNumbersOnly: true,
  length: 6,
  isPasswordInput: false,
  disableAutoFocus: false,
  placeholder: '',
  inputStyles: {
    'width': '50px',
    'height': '50px'
  }
};